/**
 * @file Frontend API client — landingService.
 */

import publicAxiosClient from "../api/publicAxiosClient";
import { API_URLS } from "../constants/apiUrls";

/** Type definition — Publication Source Counts. */
export interface PublicationSourceCounts {
  peerReviewedScientificLiterature: number;
  internalTechnicalReports: number;
  epdsAndLcas: number;
}

/** Type definition — Landing Stats. */
export interface LandingStats {
  datasetsCount: number;
  materialsCoveredCount: number;
  publicationSourceCounts: PublicationSourceCounts;
}

/** Type definition — Landing Stats Response. */
export interface LandingStatsResponse {
  success: boolean;
  data: LandingStats;
}

const defaultPublicationSourceCounts: PublicationSourceCounts = {
  peerReviewedScientificLiterature: 0,
  internalTechnicalReports: 0,
  epdsAndLcas: 0,
};

/** Exported const — landing Service. */
export const landingService = {
  getStats: async (): Promise<LandingStats> => {
    const res = await publicAxiosClient.get<LandingStatsResponse>(
      API_URLS.LANDING.STATS
    );
    const data = res.data.data;
    return {
      ...data,
      publicationSourceCounts:
        data.publicationSourceCounts ?? defaultPublicationSourceCounts,
    };
  },
};
